// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_omQ","cls2":"SingularMentionCitationModal-cls2_9gN SingularMentionCitationModal-cls1_omQ"};